angular.module('tgaAdmin').controller('UserController', [
  '$scope',
  '$state',
  '$filter',
  '$uibModal',
  'userService',
  'flashService',
  'customFieldService',
  'gameService',
  'modalService',
  'settingsService',
  'divisionService',
  '$translate',
  'authService',
  'constants',
  'domainService',
  function (
    $scope,
    $state,
    $filter,
    $uibModal,
    userService,
    flashService,
    customFieldService,
    gameService,
    modalService,
    settingsService,
    divisionService,
    $translate,
    authService,
    constants,
    domainService,
  ) {
    $scope.showBack = true;

    $scope.data = {
      alerts: [],
      userId: $state.params.id || null,
      isSuperAdmin: userService.checkUserType(['super_admin']),
      userTypes: constants.userTypes(!userService.checkUserType(['super_admin'])),
      userIsSuperAdmin: false,
      yesno: [
        {
          id: true,
          value: 'Yes',
        },
        {
          id: false,
          value: 'No',
        },
      ],
      customFields: [],
      gameTypes: gameService.getGameTypes(),
      games: [],
      hasGames: false,
      domains: [],
    };

    // Dynamic add for ui-select
    $scope.tagSelectItem = function (value, division) {
      const item = {
        division_id: division.division_id,
        division_option_id: null,
        value,
        label: `Add New ${division.name}`,
        labelSelected: `New ${division.name}`,
      };

      division.value = value;

      return item;
    };

    $scope.refreshSelect = function (selectObject, division) {
      if (!division.allow_add) {
        return;
      }

      if (selectObject.search) {
        if (selectObject.items.length === 0) {
          selectObject.items.push($scope.tagSelectItem(selectObject.search, division));
        } else if (selectObject.items.length === 1 && selectObject.items[0].division_option_id === null) {
          selectObject.items[0] = $scope.tagSelectItem(selectObject.search, division);
        }
      } else if (selectObject.items.length === 1 && selectObject.items[0].division_option_id === null) {
        selectObject.items = [];
      }
    };

    $scope.viewmodel = {
      user: {
        permissions: { has_limit: {} },
        divisions: [],
      }, // needed to prevent has_limit undefined on Add User page.
      password: null,
      confirmPassword: null,
      limit_viewing: false,
      custom_fields: [],
      selectedCustomField: null,
      selectedCustomFieldOption: null,
      games: [],
      game: null,
      isMe: false,
    };

    $scope.initialize = function () {
      customFieldService
        .getCustomFields()
        .then((customFields) => {
          $scope.data.customFields = customFields.filter((field) => field.type === 'dropdown');
        })
        .catch((error) => {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
            'danger',
          );
        });

      domainService.getDomains().then((domains) => {
        $scope.data.domains = domains;
      })

      if ($scope.data.userId) {
        $scope.viewmodel.isMe = parseInt($scope.data.userId, 10) === authService.getAuthentication().userId;
        userService.getUser($scope.data.userId).then((user) => {
          $scope.viewmodel.user = user;
          if ($scope.viewmodel.user.user_type === 'super_admin') {
            $scope.data.userIsSuperAdmin = true;
          }
          user.limit_viewing = userService.hasLimit(user, 'custom_fields');

          if (!user.permissions) {
            user.permissions = {};
          }

          if (!user.permissions.has_limit) {
            user.permissions.has_limit = {};
          }

          $scope.title = `<span class="text-muted">Edit User /</span> ${user.first_name} ${user.last_name}`;
        });

        gameService.getGames({ exclude_extra_data: true }).then((games) => {
          $scope.data.hasGames = games.find((g) => g.created_by === $scope.data.userId);
          $scope.data.games = games;
        });

        $scope.loading = true;

        userService.getUserGameAccess($scope.data.userId).then((games) => {
          $scope.loading = false;
          $scope.viewmodel.games = games;
        });
      } else {
        divisionService.getDivisions().then((divisions) => {
          $scope.viewmodel.user.divisions = divisions;
        });
      }

      settingsService.getSettings().then((settings) => {
        $scope.data.isSSO = settings.is_sso;

        if (settings.is_sso && settings.is_sso !== 'tga' && !$scope.data.userId) {
          $state.go('v1.users');
        }
      });
    };

    $scope.actions = {
      submit(form) {
        form.submitted = true;
        const isPasswordForm = form.$name === 'passwordForm';

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        if (form.$name === 'passwordForm' && $scope.viewmodel.password !== $scope.viewmodel.confirmPassword) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.password_no_match')
              .toString()}`,
            'danger',
          );
          return;
        }

        form.processing = true;

        const customFields = angular.copy($scope.viewmodel.user.permissions.has_limit.custom_fields);
        $scope.viewmodel.user.permissions.has_limit.custom_fields = [];

        if (customFields && customFields.length) {
          customFields.forEach((field) => {
            const options = [];
            field.options.forEach((option) => {
              if (option.checked === true) {
                const optionData = {
                  name: option.name,
                  custom_field_option_id: option.custom_field_option_id,
                };
                options.push(optionData);
                field.options = options;
              }
            });

            const fieldData = {
              custom_field_id: field.custom_field_id,
              name: field.name,
              options: field.options,
            };

            $scope.viewmodel.user.permissions.has_limit.custom_fields.push(fieldData);
          });
        }

        if ($scope.data.userId) {
          let data = {};

          if (isPasswordForm && $scope.viewmodel.isMe) {
            data = { password: $scope.viewmodel.password };
            userService.updateUserPassword(data).then(
              (response) => {
                $scope.initialize();
                let auth = authService.clearAuthentication();
                auth.isAuth = true;
                auth.token = response;
                authService.setAuthentication(auth);

                userService.getCurrentUser().then(
                  (user) => {
                    auth = authService.getAuthentication();
                    auth.isAuth = true;
                    auth.username = user.username;
                    auth.token = response;
                    auth.userId = user.id;
                    authService.setAuthentication(auth);
                    userService.setUser(user);
                  },
                ).catch(() => {
                  authService.clearAuthentication();
                  $state.go('v1.login');
                });
                $scope.actions.createAlert('<span class="fa fa-check"></span> Login information updated.', 'success');
                form.processing = false;
              },
              (error) => {
                if (data.user_type !== 'super_admin' && $scope.data.userIsSuperAdmin) {
                  $scope.data.userIsSuperAdmin = false;
                  $state.go('v1.users');
                }
                $scope.actions.createAlert(
                  `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                  'danger',
                );
                form.processing = false;
              },
            );
          } else {
            data = isPasswordForm ? {
              password: $scope.viewmodel.password,
              id: $scope.data.userId,
            } : $scope.viewmodel.user;
            const alertMessage = isPasswordForm ? 'Login information updated.' : 'User Updated.';
            userService.updateUser(data).then(
              () => {
                $scope.initialize();
                $scope.actions.createAlert(`<span class="fa fa-check"></span> ${alertMessage}`, 'success');
                if ($scope.viewmodel.user.user_type !== 'super_admin' && $scope.data.userIsSuperAdmin) {
                  $scope.data.userIsSuperAdmin = false;
                }
                form.processing = false;
              },
              (error) => {
                if (data.user_type !== 'super_admin' && $scope.data.userIsSuperAdmin) {
                  $scope.data.userIsSuperAdmin = false;
                  $state.go('v1.users');
                }
                $scope.actions.createAlert(
                  `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                  'danger',
                );
                form.processing = false;
              },
            );
          }
        } else {
          userService.addUser($scope.viewmodel.user).then(
            (response) => {
              userService.assignUserToDomains({user_id: response.id, domains: response.domains}).then(() => {
                flashService.set('<span class="fa fa-check"></span> User added.', 'success');
                form.processing = false;
                form.submitted = false;
                $state.go('v1.users');
              },
                (error) => {
                  $scope.actions.createAlert(
                    `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                    'danger',
                  );
                  form.processing = false;
                },
              )
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              form.processing = false;
            },
          );
        }
      },
      deleteUser() {
        $scope.data.alerts = [];

        modalService
          .showModal(
            {
              title: 'Delete User?',
              message: 'Are you sure you want to delete this user from your account?',
              closeButton: 'No',
              actionButton: 'Yes',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(() => {
            $scope.loading = true;

            userService.deleteUser($scope.viewmodel.user.id).then(
              () => {
                flashService.set('<span class="fa fa-check"></span> User removed.', 'success');
                $scope.loading = false;
                $state.go('v1.users');
              },
              (error) => {
                $scope.actions.createAlert(
                  `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                  'danger',
                );
                $scope.loading = false;
              },
            );
          })
          .catch(angular.noop);
      },
      toggleGameTransferModal() {
        $uibModal
          .open({
            animation: false,
            templateUrl: 'templates/partials/modal-game-transfer.html',
            controller: 'GameTransferModalController',
            backdrop: true,
            size: 'lg',
            resolve: {
              extras() {
                return {
                  closeButton: true,
                  transfer_from: $scope.viewmodel.user,
                };
              },
            },
          })
          .result.then(() => {
            gameService.destroy();
            $scope.actions.createAlert('<span class="fa fa-check"></span> Games transfered.', 'success');
            $scope.initialize();
          })
          .catch(angular.noop);
      },
      addUserGameAccess(form) {
        form.submitted = true;
        $scope.data.alerts = [];

        if (form.$invalid) {
          return;
        }

        form.processing = true;

        $scope.viewmodel.game.user_id = $scope.data.userId;
        $scope.viewmodel.game.user_type = $scope.viewmodel.user.user_type;

        userService.addUserGameAccess($scope.viewmodel.game).then(
          () => {
            $scope.actions.createAlert('<span class="fa fa-check"></span> Game access updated.', 'success');
            form.processing = false;
            form.submitted = false;
            $scope.viewmodel.game = null;
            $scope.initialize();
          },
          (error) => {
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
              'danger',
            );
            form.processing = false;
          },
        );
      },
      assignUserToDomains(form) {
        form.submitted = true;
        $scope.data.alerts = [];

        // User needs to be created before it can be assigned a domain
        if (form.$invalid || !$scope.data.userId) {
          return;
        }

        form.processing = true;

        userService.assignUserToDomains({user_id: $scope.viewmodel.user.id, domains: $scope.viewmodel.user.domains}).then(() => {
          $scope.actions.createAlert('<span class="fa fa-check"></span> User domains updated.', 'success');
          form.processing = false;
          form.submitted = false;
        },
          (error) => {
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
              'danger',
            );
            form.processing = false;
          },
        )
      },
      addAll(form) {
        const data = {
          all_games: true,
          user_id: $scope.data.userId,
          user_type: $scope.viewmodel.user.user_type,
        };

        form.processing = true;

        userService.addUserGameAccess(data).then(
          () => {
            $scope.actions.createAlert('<span class="fa fa-check"></span> Game access updated.', 'success');
            $scope.viewmodel.userEditor = null;
            $scope.viewmodel.userViewer = null;
            form.submitted = false;
            form.processing = false;
            $scope.initialize();
          },
          (error) => {
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
              'danger',
            );
            form.processing = false;
          },
        );
      },
      removeUserAccess(game) {
        modalService
          .showModal(
            {
              title: 'Remove Game Access?',
              message: "Are you sure you want remove this user's access?",
              closeButton: 'No',
              actionButton: 'Yes',
            },
            {
              backdrop: true,
              keyboard: true,
              animation: false,
            },
          )
          .then(
            () => {
              game.processing = true;

              userService.deleteUserAccess(game.game_access_id).then(
                () => {
                  $scope.actions.createAlert('<span class="fa fa-check"></span> Game access updated.', 'success');
                  $scope.initialize();
                },
                (error) => {
                  $scope.actions.createAlert(
                    `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                    'danger',
                  );
                  game.processing = false;
                },
              );
            },
            () => {},
          );
      },
      changeLimit() {
        $scope.viewmodel.user.permissions.has_limit.custom_fields = [];
      },
      notAdded(game) {
        const added = $scope.viewmodel.games.filter((g) => g.game_id === game.game_id);

        return added.length === 0;
      },
      changeCustomField() {
        const found = $scope.viewmodel.user.permissions.has_limit.custom_fields.find(
          (field) => field.custom_field_id === $scope.viewmodel.selectedCustomField.custom_field_id,
        );

        if (!found) {
          $scope.viewmodel.selectedCustomField.showCheckbox = true;
          $scope.viewmodel.user.permissions.has_limit.custom_fields.push(
            angular.copy($scope.viewmodel.selectedCustomField),
          );
          $scope.viewmodel.selectedCustomField = null;
        }
      },
      checkBox(options) {
        const notRequired = options.find((opt) => opt.checked === true);
        return !notRequired;
      },
      removeField(field) {
        const index = $scope.viewmodel.user.permissions.has_limit.custom_fields.indexOf(field);

        if (index > -1) {
          $scope.viewmodel.user.permissions.has_limit.custom_fields.splice(index, 1);
        }
      },
      toggleTwoFactor() {
        $scope.viewmodel.user.two_factor_enabled = !$scope.viewmodel.user.two_factor_enabled;
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
    };

    $scope.initialize();
  },
]);
